// extracted by mini-css-extract-plugin
export default {"outOfStock":"BnVCv","icon":"mGufL","text":"jpOkM"};